import React from "react";
import { useNavigate } from "react-router-dom";

const CardCTA = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/biodata");
  };

  const patternText = "YOU READY? ARE ";
  const bgRows = [
    { id: 1, offsetClass: "-translate-x-[3%] lg:translate-x-[1%]" },
    { id: 2, offsetClass: "-translate-x-[16%] lg:-translate-x-[10%]" },
    { id: 3, offsetClass: "-translate-x-[6%] lg:-translate-x-[2%]" },
    { id: 4, offsetClass: "-translate-x-[20%] lg:-translate-x-[12%]" },
    { id: 5, offsetClass: "-translate-x-[8%] lg:-translate-x-[4%]" },
  ];

  return (
    <section className="st-surface-cream px-0 pb-8 pt-0 sm:pb-10">
      <div className="relative overflow-hidden bg-[#1F2A70] px-4 py-8 sm:px-6 sm:py-10 md:px-8 md:py-12 lg:py-20 xl:py-24">
        <div className="pointer-events-none absolute inset-0 flex flex-col justify-between py-2" aria-hidden="true">
          {bgRows.map((row) => (
            <p
              key={row.id}
              className={`st-font-body whitespace-nowrap text-left text-[54px] font-extrabold leading-none tracking-tight text-[#3C4A8D] sm:text-[66px] lg:text-[180px] ${row.offsetClass}`}
            >
              {patternText.repeat(8)}
            </p>
          ))}
        </div>

        <div className="relative mx-auto my-3 max-w-5xl rounded-[42px] bg-[#F6F2E9] px-5 py-9 shadow-[0_18px_40px_rgba(0,0,0,0.2)] sm:px-8 sm:py-11 md:-rotate-[1.8deg] md:px-12 md:py-14 lg:my-10">
          <div className="md:rotate-[1.8deg]">
            <h2 className="st-font-display text-center text-[50px] leading-[1.02] text-[#111111] sm:text-[62px] lg:text-[78px] lg:leading-[1.12] lg:tracking-[0.005em]">
              <span className="italic">Yuk, </span>
              <span className="font-semibold not-italic">Mulai</span>
              <span className="italic"> Perjalananmu</span>
              <br />
              <span className="not-italic">dengan </span>
              <span className="italic">Placement</span>
              <span className="font-semibold not-italic"> Test!</span>
            </h2>

            <p className="st-font-body mx-auto mt-6 max-w-[740px] text-center text-lg leading-[1.4] text-[#222222] sm:text-xl lg:mt-8 lg:max-w-[820px] lg:text-[34px] lg:leading-[1.5]">
              Cukup beberapa langkah mudah, kamu bisa tahu posisi
              <br />
              kamu sekarang. Siap naik level?
            </p>

            <div className="mt-9 flex flex-wrap items-center justify-center gap-x-2 gap-y-3 sm:gap-x-4 md:flex-nowrap md:gap-y-0 lg:mt-12 lg:gap-8">
              <span className="order-2 st-placement-pill px-4 py-2 text-[14px] sm:px-6 sm:text-[18px] md:order-none lg:text-[28px]">
                Free &amp; Fun
              </span>

              <button
                type="button"
                onClick={handleButtonClick}
                className="order-1 basis-full st-placement-cta-btn st-placement-cta-btn-red px-8 py-2.5 text-[16px] sm:basis-auto sm:px-10 sm:text-[20px] md:order-none lg:px-14 lg:py-3 lg:text-[32px]"
              >
                Start Now!
              </button>

              <span className="order-3 st-placement-pill px-4 py-2 text-[14px] sm:px-6 sm:text-[18px] md:order-none lg:text-[28px]">
                Anti Ribet
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CardCTA;
